import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/**
 * Action types & creators
 */
const { Types, Creators } = createActions({
  loadCustomers: ['partner'],
  loadCustomersSuccess: ['data'],
  resetCustomers: [],
  loadCustomer: ['partner', 'customer'],
  loadCustomerSuccess: ['data'],
  resetCustomer: [],
  updateCustomer: ['partner', 'customer', 'data'],
  updateCustomerSuccess: [],
  addCustomer: ['partner', 'data'],
  addCustomerSuccess: [],
  removeCustomer: ['partner', 'customer']
});

export { Types };

export default Creators;

/**
 * Handlers
 */
const INITIAL_STATE = Immutable({
  all: {
    loading: true,
    data: {
      total: 1,
      start: 0,
      sort: null,
      remaining: 0,
      order: 'asc',
      entries: [],
      count: 20
    }
  },
  single: {
    loading: true,
    data: {
      name: '',
      document: '',
      email: '',
      phone: '',
      zip_code: '',
      neighborhood: '',
      street_name: '',
      street_number: '',
      complement: '',
      city: '',
      state: ''
    }
  }
});

const loadCustomersSuccess = (state, action) => ({
  ...state,
  all: {
    loading: false,
    updating: false,
    data: action.data
  }
});

const resetCustomers = (state, action) => ({
  ...state,
  all: INITIAL_STATE.all
});

const loadCustomerSuccess = (state, action) => ({
  ...state,
  single: {
    loading: false,
    data: action.data
  }
});

const resetCustomer = (state, action) => ({
  ...state,
  single: INITIAL_STATE.single
});

const updateCustomer = (state, action) => ({
  ...state,
  single: {
    ...state.single,
    updating: true
  }
});

const updateCustomerSuccess = (state, action) => ({
  ...state,
  single: {
    ...state.single,
    updating: false
  }
});

const addCustomer = (state, action) => ({
  ...state,
  single: {
    ...state.single,
    adding: true
  }
});

const addCustomerSuccess = (state, action) => ({
  ...state,
  single: {
    ...state.single,
    adding: false
  }
});

/**
 * Reducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.LOAD_CUSTOMERS]: resetCustomers,
  [Types.LOAD_CUSTOMERS_SUCCESS]: loadCustomersSuccess,
  [Types.RESET_CUSTOMERS]: resetCustomers,
  [Types.LOAD_CUSTOMER]: resetCustomer,
  [Types.LOAD_CUSTOMER_SUCCESS]: loadCustomerSuccess,
  [Types.RESET_CUSTOMER]: resetCustomer,
  [Types.UPDATE_CUSTOMER]: updateCustomer,
  [Types.UPDATE_CUSTOMER_SUCCESS]: updateCustomerSuccess,
  [Types.ADD_CUSTOMER]: addCustomer,
  [Types.ADD_CUSTOMER_SUCCESS]: addCustomerSuccess
});
